import { Button, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import {
    Autocomplete,
    TextField
} from '@mui/material/';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import React, { useContext, useState, useEffect } from 'react';
import '../App.css';
import CleanedDataTable from "./CleanedDataTable";
import CustomSnackbar from '../CustomSnackbar';
import StatisticDataTables from "./StatisticDataTables";
import { SystemContext } from "../context";
import axios from "axios";
import ReactDOM from 'react-dom';
import SummaryDataTables from './SummaryDataTables';



const FullTextTooltip = ({ text, position }) => {
    if (!position) return null;

    return ReactDOM.createPortal(
        <div style={{
            position: 'fixed',
            left: `${position.x}px`,
            top: `${position.y}px`,
            transform: 'translate(-50%, -100%)',
            backgroundColor: 'white',
            border: '1px solid #ccc',
            padding: '8px',
            zIndex: 9999,
            boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
            maxWidth: '300px',
            wordBreak: 'break-word',
            // textAlign: 'center',
            pointerEvents: 'none',
            marginLeft: '185px',
            marginTop: '25px'
        }}>
            {text}
        </div>,
        document.body
    );
};



const UploadAndCleanData = ({ fetchAPI }) => {

    const [numericalModeList, setNumericalModeList] = useState(["Mean", "Mode", "Median", "Forward fill", "Backward fill", "Interpolation", "KNN Imputer", "Iterative Imputer"]);
    const [outlierMethodList,setOutlierMethodList]=useState(["None","Univariate","MultiVariate"]);
    const [categoricalModeList, setCategoricalModeList] = useState(["Mode", "Forward fill", "Backward fill"]);
    const [outliersList, setOutliersList] = useState(["Mahalanobis distance", "Elliptic envelope"]);
    const [outliersList1, setOutliersList1] = useState(["IQR", "Z-score"]);
    const [jsonData, setJsonData] = useState([]);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState(null);

    const { numberOfRows, setNumberOfRows, numberOfColumns, setNumberOfColumns,
        numberOfDuplicateRows, setNumberOfDuplicateRows,
        numberOfDuplicateColumns, setNumberOfDuplicateColumns, statsData, setStatsData, numericalModeValue, setNumericalModeValue,
        categoricalModeValue, setCategoricalModeValue, outliersValue, setOutliersValue, fileObjects, setfileObjects,
        outlinerMethod, setOutlinerMethod, fileName, setFileName, cleanedData, setCleanedData, allColumns, setAllColumns,
        categoricalStatsData, setCategoricalStatsData, numericalColumns, setNumericalColumns, stringColumns, setStringColumns,
        missingData, setMissingData, numericalStatsCol, setNumericalStatsCol, numericalStatsData, setNumericalStatsData, categoricalStatsCol, setCategoricalStatsCol,
        timeStampCols, setTimeStampCols, numericalCleanedCols, setNumericalCleanedCols, categoricalCleanedCols, setCategoricalCleanedCols,
        allCleanedCols, setAllCleanedCols, cleaningInfo, setCleaningInfo, dupCols, setDupCols, cleanFlag, setCleanFlag,
        noOfRowsAfterCleaning, setNoOfRowsAfterCleaning, noOfColsAfterCleaning, setNoOfColsAfterCleaning, balancedCols, setBalancedCols, 
        actualFileName, setActualFileName,openDrawer
    } = useContext(SystemContext);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarType, setSnackbarType] = useState('');
    const [numericalError, setNumericalError] = useState(false);
    const [categoricalError, setCategoricalError] = useState(false);
    const [outlierError, setOutlierError] = useState(false);
    const [snackbarOpenForCleaning, setSnackbarOpenForCleaning] = useState(false);
    const [uploadStatusMsg, setUploadStatusMsg] = useState('');
    const [cleanStatusMsg, setCleanStatusMsg] = useState('');

    const numericalModeOnChange = (evt, value) => {
        setNumericalModeValue(value);
        setNumericalError(false);
    }
    const categoricalModeOnChange = (evt, value) => {
        setCategoricalModeValue(value);
        setCategoricalError(false);
    }
    const outliersModeOnChange = (evt, value) => {
        setOutliersValue(value);
        setOutlierError(false);
    }

    const [file, setFile] = useState(null);

    const handleFileChange = (event) => {
            if(event.target.files[0]!=null){
                setFile(event.target.files[0]);
                setFileName(event.target.files[0].name);
            }
    };

    // const handleSubmit = async (event) => {
    //     if (file === null) {
    //         alert("Please choose the file..")
    //         return
    //     }
    //     setLoading(true);
    //     event.preventDefault();
    //     const formData = new FormData();
    //     formData.append('file', file);

    //     try {
    //         const response = await fetchAPI.post('/upload', formData, {
    //             headers: {
    //                 'Content-Type': 'multipart/form-data',
    //                 Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
    //             }
    //         });
    //         // const res= await fetchAPI.post('/pre_signed_url', formData, {
    //         //     headers: {
    //         //         'Content-Type': 'multipart/form-data',
    //         //         Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
    //         //     }
    //         //     body:
    //         // });
    //         const data = response.data.json_data;
    //         if (response.status == 200) {
    //             setUploadStatusMsg(response.data.message)
    //             setSnackbarOpen(true);
    //             setSnackbarType("success")
    //         }
    //         setNumberOfRows(data['datapoints'])
    //         setNumberOfColumns(data['features'])
    //         setStatsData(data['n_stats'])
    //         setNumericalStatsData(Object.values(data['n_stats']))
    //         setNumericalStatsCol(Object.keys(data['n_stats']))
    //         setCategoricalStatsData(Object.values(data['cstats']))
    //         setCategoricalStatsCol(Object.keys(data['cstats']))
    //         setAllColumns(data['cols'])
    //         setNumberOfDuplicateRows(data['dup_rows'])
    //         setNumberOfDuplicateColumns(data['dup_cols'])
    //         setNumericalColumns(data['num_cols'])
    //         setStringColumns(data['cat_cols'])
    //         setMissingData(data['missing_values']);
    //         setCleanedData([])

    //     } catch (error) {
    //         setUploadStatusMsg(error.response.data.message)
    //         console.error('Error in uploading file:', error);
    //         setSnackbarType("error")
    //         setSnackbarOpen(true);
    //     }
    //     setLoading(false);
    // };

    const handleSubmit = async (event) => {
        if (file === null) {
            alert("Please choose the file..");
            return;
        }

        setLoading(true);
        event.preventDefault();
        const filename = file.name;

        try {
            const presignedResponse = await fetchAPI.post('/pre_signed_url', { filename }, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                }
            });

            const { fields, url, actual_name } = presignedResponse.data;
            setActualFileName(actual_name);

            const formData = new FormData();
            for (const [key, value] of Object.entries(fields)) {
                formData.append(key, value);
            }
            formData.append('file', file);

            const uploadResponse = await axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (uploadResponse.status === 204 || uploadResponse.status === 200) {
                console.log('File uploaded successfully to S3');

                const checkUploadStatus = async () => {
                    try {
                        const statusResponse = await fetchAPI.post('/upload_stats', { filename: actual_name }, {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                            }
                        });

                        if (statusResponse.status === 200) {
                            const data = statusResponse.data.json_data;
                            setUploadStatusMsg(statusResponse.data.message);
                            setSnackbarOpen(true);
                            setSnackbarType("success");
                            setNumberOfRows(data['datapoints']);
                            setNumberOfColumns(data['features']);
                            setStatsData(data['n_stats']);
                            setNumericalStatsData(Object.values(data['n_stats']));
                            setNumericalStatsCol(Object.keys(data['n_stats']));
                            setCategoricalStatsData(Object.values(data['cstats']));
                            setCategoricalStatsCol(Object.keys(data['cstats']));
                            setAllColumns(data['cols']);
                            setNumberOfDuplicateRows(data['dup_rows']);
                            setNumberOfDuplicateColumns(data['dup_cols']);
                            setNumericalColumns(data['num_cols']);
                            setStringColumns(data['cat_cols']);
                            setMissingData(data['missing_values']);
                            setCleanedData([]);
                            setLoading(false);
                        } else {
                            console.log('Waiting for upload status to complete...');
                            setTimeout(checkUploadStatus, 2000);
                        }
                    } catch (error) {
                        setUploadStatusMsg(error.message);
                        console.error('Error checking upload status:', error);
                        setLoading(false);
                        setSnackbarType("error");
                        setSnackbarOpen(true);
                    }
                };

                checkUploadStatus();

            } else {
                throw new Error('Error uploading file to S3');
            }

        } catch (error) {
            setUploadStatusMsg(error.message);
            console.error('Error in uploading file:', error);
            setLoading(false);
            setSnackbarType("error");
            setSnackbarOpen(true);
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const handleSnackbarCloseForCleaning = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpenForCleaning(false);
    };

    const [loading, setLoading] = useState(false);

    const handleCleaning = async (event) => {
        let flag = false;
    
        if (!numericalModeValue) {
            setNumericalError(true);
            flag = true;
        }
        if (!categoricalModeValue) {
            setCategoricalError(true);
            flag = true;
        }
        // if (!outliersValue) {
        //     setOutlierError(true);
        //     flag = true;
        // }
        if (flag) {
            return;
        }
        setLoading(true);
    
        const data_sys = {
            "impute_num": numericalModeValue,
            "impute_cat": categoricalModeValue,
            "outlier_method": outlinerMethod,
            "detect_outlier": outliersValue,
            "filename": actualFileName,
        };
        try {
            const response = await fetchAPI.post('/clean_data', data_sys, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                }
            });
    
            if (response.status === 202) {
                const pollForStats = async () => {
                    try {
                        const statsResponse = await fetchAPI.post('/clean_stats', { filename: actualFileName }, {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                            }
                        });
                        
                        if (statsResponse.status === 200) {
                            const statsData = statsResponse.data.json_data;
    
                            setCleanedData(statsData.data);
                            setTimeStampCols(statsData.timestamp);
                            setNumericalCleanedCols(statsData.num_cols);
                            setCategoricalCleanedCols(statsData.cat_cols);
                            setAllCleanedCols([...statsData.num_cols, ...statsData.cat_cols]);
                            setCleaningInfo(statsData.cleaning_info);
                            setDupCols(statsData.dup_cols);
                            setCleanFlag(true);
                            setNoOfRowsAfterCleaning(statsData.cleaning_info.rows_count);
                            setNoOfColsAfterCleaning(statsData.cleaning_info.cols_count);
                            setBalancedCols(statsData.balanced_columns);
                            setCleanStatusMsg("Cleaning successful!");
                            setSnackbarOpenForCleaning(true);
                            setSnackbarType("success");
                            setLoading(false);
                        } else {
                            setTimeout(pollForStats, 2000);
                        }
                    } catch (error) {
                        console.error('Error fetching stats:', error);
                        setTimeout(pollForStats, 2000);
                    }
                };
    
                pollForStats();
    
            } else {
                setCleanStatusMsg("Unexpected response from server.");
                setSnackbarType("error");
                setSnackbarOpenForCleaning(true);
                setLoading(false);
            }
        } catch (error) {
            setCleanStatusMsg(error.response?.data?.message || 'Error during cleaning process');
            console.error('Error during cleaning process:', error);
            setSnackbarType("error");
            setSnackbarOpenForCleaning(true);
            setLoading(false);
        }
    };
    


    const handleDetectOutlinerMethod = (event,value) => {
        console.log(event.target.value)
        setOutlinerMethod(value)
        setOutliersValue("")
    }

    const overlayStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000,
    };

    const boxStyle = {
        borderRadius: "15px",
        border: "2px solid #ccc",
        padding: "20px",
        margin: "20px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        backgroundColor: "#f9f9f9",
        width: "84vw",
        // maxWidth: "1200px",
        boxSizing: "border-box",
        overflowX: 'auto',
    };

    const parentStyle = {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: 'center',
    };

    const innerContentStyle = {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'start',
        // maxWidth: '70vw',
        flexDirection: 'column',
    };

    const rowStyle = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        boxSizing: "border-box",
    };

    const autocompleteStyle = {
        flexGrow: 1,
        marginLeft: '1rem',
        width: '200px'
    };

    const headingStyle = {
        color: '#152C73',
        display: 'flex',
        marginLeft: openDrawer ? '2rem' : '8rem',
        height: '1vh'
    };
    const paragraphStyle = {
        // minWidth: '250px',
        whiteSpace: 'nowrap',
        textAlign: 'left',
        marginRight: '1rem',
        display: 'flex',
        flexDirection: 'row'
    };
    const labelStyle = {
        color: '#152C73',
        marginRight: '1rem',
        display: 'flex',
    };
    const nameStyle = {
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '350px', // Adjust based on your requirement
        // position: 'relative',
    };

    const lastAccessStyle = {
        fontSize: '0.85em',
        color: 'grey',
    };

    const optionStyles = {
        display: 'flex',
        flexDirection: 'column',
        padding: '15px 5px',
        whiteSpace: 'nowrap',
        position: 'relative',

    };

    const fullTextStyle = {
        position: 'absolute',
        top: '100%',
        left: 0,
        whiteSpace: 'wrap',
        backgroundColor: 'white',
        border: '1px solid #ccc',
        padding: '3px',
        zIndex: 1000,
        display: 'block',
        // overflow:'auto'
        boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
        maxWidth: '100%',
        // wordBreak: 'break-word'
    };

    const optionContainerStyle = {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
    };

    const handleMouseEnter = (event, index) => {
        const rect = event.currentTarget.getBoundingClientRect();
        setHoveredIndex(index);
        setTooltipPosition({ x: rect.left, y: rect.bottom + window.scrollY });
    };

    const handleMouseLeave = () => {
        setHoveredIndex(null);
        setTooltipPosition(null);
    };

    useEffect(() => {
        const fetchJsonData = async () => {
            try {
                const response = await fetchAPI.get('/user_jobs', {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                    }
                });
                const data = response.data.job_list
                setJsonData(data);
            } catch (error) {
                console.error('Error fetching JSON data:', error);
            }
        };
        fetchJsonData();
    }, []);
    return (
        <>
            <form>
                <div style={{ display: 'flex', width: 'auto', flexDirection: 'row', marginTop: '2rem', marginBottom: '2rem', alignItems: 'center', justifyContent: 'center' }}>

                {/* <Autocomplete
                        options={jsonData}
                        getOptionLabel={(option) => option.name}
                        renderOption={(props, option, { index }) => (
                            <li
                                {...props}
                                style={optionStyles}
                                onMouseEnter={(e) => handleMouseEnter(e, index)}
                                onMouseLeave={handleMouseLeave}
                            >
                                <div style={optionContainerStyle}>
                                    <span style={nameStyle}>{option.name}</span>
                                </div>
                                <span style={lastAccessStyle}>Last accessed: {option.last_access}</span>
                            </li>
                        )}
                        renderInput={(params) => <TextField {...params} label="Old workspace" />}
                        sx={{ height: '15%', minWidth: '380px', width: 'auto', margin: '10px' }}
                        ListboxProps={{
                            style: { maxHeight: '300px', overflow: 'auto' }
                        }}
                    /> */}
                    <FullTextTooltip
                        text={hoveredIndex !== null ? jsonData[hoveredIndex].name : ''}
                        position={tooltipPosition}
                    />

                    {/* <div>
                        <label htmlFor="jsonDataDropdown">Select from JSON data:</label>
                        <select id="jsonDataDropdown" style={{ width: '250px', margin: '15px' }} style={dropdown}>
                            {jsonData.map((item, index) => (
                                <option key={index} value={item.name}>
                                    {item.name} - Last accessed: {item.last_access}
                                </option>
                            ))}
                        </select>
                    </div> */}



                    <div class="input_container">
                        <input type="file" id="fileUpload"
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            onChange={handleFileChange} />
                    </div>
                    <div>
                        <Button variant="contained"
                            color="primary"
                            style={{ display: 'flex', marginLeft: '1rem' ,borderRadius:'16px'}}
                            onClick={handleSubmit}
                            z disabled={fileName === ""}
                        >Upload</Button>
                    </div>

                </div>

            </form>
            <CustomSnackbar open={snackbarOpen} onClose={handleSnackbarClose} snackbarType={snackbarType}
                message={
                    snackbarType === 'success' ? uploadStatusMsg :
                        snackbarType === 'warning' ? "Upload warning" :
                            snackbarType === 'error' ? uploadStatusMsg :
                                ""
                }
            />

            {numericalStatsCol && numericalStatsCol.length > 0 ?
                <>
                    <h2 style={headingStyle}><b>Summary</b></h2>
                    {/* <StatisticDataTables numericData={numericalStatsData} numericColumns={numericalStatsCol}
                        categoricalData={categoricalStatsData} categoricalColumns={categoricalStatsCol} missingGraphsdata={missingData} /> */}
                     <br/>
                    <SummaryDataTables numericData={numericalStatsData} numericColumns={numericalStatsCol}
                        categoricalData={categoricalStatsData} categoricalColumns={categoricalStatsCol} missingGraphsdata={missingData} />
                </> : ""}

            {numericalStatsCol && numericalStatsCol.length > 0 ?
                <>
                    <h2 style={headingStyle}><b>Data Cleaning</b></h2>
                    <div style={parentStyle}>
                        <div style={boxStyle}>
                            <div style={innerContentStyle}>
                                <div style={rowStyle}>
                                    <h3 style={{ ...labelStyle }}><b>Missing value imputation methods</b></h3>
                                    <Autocomplete id="combo-box-demo"
                                        options={numericalModeList}
                                        value={numericalModeValue}
                                        fullWidth
                                        // style={{ display: 'flex', width: '200px' }}
                                        style={autocompleteStyle}
                                        autoHighlight
                                        onChange={numericalModeOnChange}
                                        renderInput={(params) => <TextField {...params}
                                            label="For numerical features"
                                            placeholder='Choose the strategy to impute values for numerical features'
                                            error={numericalError}
                                            helperText={numericalError ? 'Please select a strategy' : ''}

                                        />}
                                    />
                                    <Autocomplete
                                        options={categoricalModeList}
                                        value={categoricalModeValue}
                                        fullWidth
                                        // style={{ display: 'flex', marginLeft: '1rem', width: '200px' }}
                                        style={autocompleteStyle}
                                        autoHighlight
                                        onChange={categoricalModeOnChange}
                                        renderInput={(params) => <TextField {...params}
                                            label="For categorical features"
                                            placeholder='Choose the strategy to impute values for categorical features'
                                            error={categoricalError}
                                            helperText={categoricalError ? 'Please select a strategy' : ''}
                                        />}
                                    />
                                </div>
                                <br/>
                                <div style={rowStyle}>
                                    <h3 style={{ ...labelStyle }}><b>Outlier detection methods</b></h3>
                                    {/* <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        style={{ marginLeft: '1rem' }}
                                        onChange={handleDetectOutlinerMethod}
                                        value={outlinerMethod}
                                    >
                                        <FormControlLabel value="Univariate" control={<Radio />} label="Univariate" />
                                        <FormControlLabel value="Multivariate" control={<Radio />} label="Multivariate" />

                                    </RadioGroup> */}
                                    <Autocomplete 
                                        options={outlierMethodList}
                                        value={outlinerMethod}
                                        fullWidth
                                        style={{ display: 'flex', width: '520px',marginLeft:"5.9rem" }}
                                        // style={autocompleteStyle}
                                        autoHighlight
                                        onChange={handleDetectOutlinerMethod}
                                        renderInput={(params) => <TextField {...params}
                                            label="For outlier method"
                                            placeholder='Choose the strategy for Outlier'
                                            error={numericalError}
                                            helperText={numericalError ? 'Please select a Outlier' : ''}

                                        />}
                                    />
                                    <Autocomplete
                                        options={outlinerMethod == "Univariate" ? outliersList1 : outliersList}
                                        fullWidth
                                        // style={{ display: 'flex', width: '250px' }}
                                        style={autocompleteStyle}
                                        value={outliersValue}
                                        autoHighlight={true}
                                        onChange={outliersModeOnChange}
                                        renderInput={(params) => <TextField {...params}
                                            label="Strategy"
                                            placeholder='Choose the strategy to remove outliers'
                                            error={outlierError}
                                            helperText={outlierError ? 'Please select a strategy' : ''}

                                        />}
                                    />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'start', marginTop: '1rem' }}>
                                    <Button
                                        type="button"
                                        variant="contained"
                                        color="primary"
                                        onClick={handleCleaning}
                                        style={{
                                            // display: 'flex',
                                            // marginLeft: '1rem',
                                            borderRadius: '16px', // Add border radius here
                                        }}
                                    >
                                        Perform data cleaning
                                    </Button>
                                    {loading && (
                                        <div style={overlayStyle}>
                                            <div className="loader"></div>
                                        </div>
                                    )}
                                </div>
                                <div style={{ display: 'flex', height: '40rem', maxWidth: '72vw', flexDirection: 'column', marginTop: '2rem' }}>
                                    <CustomSnackbar open={snackbarOpenForCleaning} onClose={handleSnackbarCloseForCleaning} snackbarType={snackbarType}
                                        message={
                                            snackbarType === 'success' ? cleanStatusMsg :
                                                snackbarType === 'warning' ? "Data cleaning warning." :
                                                    snackbarType === 'error' ? cleanStatusMsg :
                                                        ""
                                        }
                                    />
                                    <div>
                                        {cleanedData && cleanedData.length > 0 ? (
                                            <Card style={{ backgroundColor: '#f5f5f5', }}>
                                                <CardContent>
                                                    {/* <Alert  severity="success" style={{width:"50%",backgroundColor:"#ceeace"}}>Data cleaning successful.</Alert> */}
                                                    <h3 style={{ ...labelStyle, marginLeft: '1rem', minWidth: '200px', textAlign: 'start' }}><b>Insights</b></h3>
                                                    <div style={paragraphStyle}>

                                                        <ul>

                                                            {cleaningInfo.outlier_count > 0 && <li>Outliers removed : {cleaningInfo.outlier_count} </li>}
                                                            {cleaningInfo.missing_count === 0 && <li>All the missing values present are imputed</li>}
                                                            {cleaningInfo.dup_rows > 0 && <li>Duplicate data points removed : {cleaningInfo.dup_rows}</li>}
                                                            {dupCols.length > 0 && <li>Duplicate features removed : {dupCols.length}</li>}
                                                            {cleaningInfo.cols_with_dups > 0 && <li>{cleaningInfo.cols_with_dups} features having constant value are removed</li>}
                                                        </ul>
                                                        <ul>
                                                            {<li>Number of data points after cleaning : {noOfRowsAfterCleaning}</li>}
                                                            {<li>Number of features after cleaning : {noOfColsAfterCleaning}</li>}
                                                        </ul>
                                                    </div>
                                                </CardContent>
                                            </Card>
                                        ) : (
                                            ""
                                        )}
                                        {cleanedData && cleanedData.length > 0 ? <CleanedDataTable data={cleanedData} /> : ""}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </> : ""}

            {loading && (
                <div style={overlayStyle}>
                    <div className="loader"></div>
                </div>
            )}

            {/* <CleanedFixedSizeTable data={cleanedData} />  */}

        </>
    );
}

export default UploadAndCleanData;